import { FormControl, TextField, Grid, Box,Button } from '@mui/material';

export const TextForExitPass = ({useFetchInit, dataModal}) => {

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { modalOpeningMode } = globalStates
    
    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { ExitPassForm } = Forms
    const { formState, onInputChange } = ExitPassForm
    
    // ------------------------------------------------ FetchData
    
    // ------------------------------------------------ Actions
    const { onSubmitExistPassModal } = Actions
    

    const { dataRequest } = dataModal
    // console.log(dataModal)
    // console.log(dataRequest)


    return (
        <>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth>
                        <label htmlFor="titularTextToAdd">Titular que retira</label>
                        <TextField
                            id="titularTextToAdd"
                            name="titularTextToAdd"
                            value={formState.titularTextToAdd}
                            onChange={onInputChange}
                            // label='Marca'
                            size='small'
                            type="text"
                            variant="outlined"
                            // hiddenLabel
                            InputProps={{
                                readOnly: false,
                            }}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    <FormControl fullWidth>
                        <label htmlFor="observationsToAdd">Observaciones</label>
                        <TextField 
                            id='observationsToAdd'
                            name='observationsToAdd'
                            value={ formState.observationsToAdd }
                            onChange={ onInputChange }
                            placeholder='...'
                            size='small'
                            multiline
                            rows={3}
                            type='text'
                            variant='outlined'
                            InputProps={{
                                readOnly: false
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <Box pt={4}>
                <Grid container spacing={2} justifyContent="flex-end">
                    <Grid item>
                        <Button 
                            variant='contained'
                            size='small'
                            color='success'
                            sx={{ marginRight: '8px' }}
                            onClick={() => onSubmitExistPassModal(dataRequest.idreception)}
                            disabled={false}
                        >
                            GENERAR
                        </Button>
                    </Grid>
                    
                </Grid>
            </Box>
        </>
    )
}
